import { Component, ViewEncapsulation, input } from '@angular/core';
import { StatDisplayComponent } from '../../atoms/stat-display/stat-display';

export interface StatItem {
  value: string;
  label: string;
  context?: string;
}

@Component({
  selector: 'ds-stats-block',
  templateUrl: './stats-block.html',
  styleUrl: './stats-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [StatDisplayComponent],
})
export class StatsBlockComponent {
  readonly stats = input.required<StatItem[]>();
}
